import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  addCustomRiskButton: {
    marginLeft: 8,
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      marginLeft: 4
    },
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      marginLeft: 2
    }
  }
}));
